<template>
  <footer class="main-footer">
    {{ $t("realizado_por") }}
    <a href="https://www.linkedin.com/in/sergiorazza/" target="_blank">
      <strong>Sergio Razza</strong>
    </a>
    {{ $t("para_el") }} <strong>Juzgado PCyF 10</strong>

    <div class="float-right">
      <span v-if="$screen.sm">
        <b>Version</b>
        1.3
      </span>
      <a href="#" @click="contacto">
        <i class="fas fa-at"></i>
      </a>
    </div>
  </footer>
</template>

<script>
export default {
  data() {
    const email =
      "\u0073\u0072\u0061\u007a\u007a\u0061\u0040\u0067\u006d\u0061\u0069\u006c\u002e\u0063\u006f\u006d";
    return {
      email,
    };
  },
  methods: {
    contacto(e) {
      e.preventDefault();
      window.open("mailto:" + this.email);
    },
  },
};
</script>

<style></style>

<i18n>
{
  "es": {
    "realizado_por" : "Realizado por ",
    "para_el" : " para el "
  },
  "en": {
    "realizado_por" : "Made by ",
    "para_el" : " for "
  }
}
</i18n>
